import axiosInstance from '@/api/axiosInstance';

export interface CategoryLocaleText {
  uz?: string;
  ru?: string;
  en?: string;
}

export interface SubCategory {
  id: number;
  createdAt: string;
  updatedAt: string;
  name: CategoryLocaleText | string;
  description?: CategoryLocaleText | string;
}

export interface Category {
  id: number;
  createdAt: string;
  updatedAt: string;
  name: CategoryLocaleText | string;
  description?: CategoryLocaleText | string;
  subCategories: SubCategory[];
}

export interface CategoryListResponse {
  data: Category[];
  total: number;
  page: number;
  totalPages: number;
}

export interface GetCategoriesParams {
  page?: number;
  limit?: number;
  search?: string;
}

export const categoriesAPI = {
  getCategories: async (
    params: GetCategoriesParams = {}
  ): Promise<CategoryListResponse> => {
    const response = await axiosInstance.get('/categories', { params });
    return response.data as CategoryListResponse;
  },
};
